import {SkuFoodCategoryCountType} from "../../../../common/types";
import ReactApexChart from "react-apexcharts";
import {Card} from "antd";
import React from "react";

// Тип пропсов для компонента: ожидает массив данных по категориям
type Top10CategoryFoodBarChartPropsType = {
    data: SkuFoodCategoryCountType[]
}

export const Top10CategoryFoodBarChart = ({data}: Top10CategoryFoodBarChartPropsType) => {

    // Массив для значений (количество позиций)
    const series: number[] = []
    // Массив для названий категорий
    const categories: string[] = []

    // Сортировка данных по количеству позиций, выбор топ-10
    const sortData = [...data].sort((a,b) => b.quantity_positions - a.quantity_positions).slice(0,10)

    // Заполнение массивов для графика
    sortData.forEach((el) => (
        series.push(el.quantity_positions), categories.push(el.name_category)
    ))

    // Опции для ApexCharts: настройки графика, заголовка, цветов, осей, тултипа и легенды
    const options = {
        chart: {
            type: 'bar' as const,
            height: 350,
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            bar: {
                borderRadius: 4,
                borderRadiusApplication: 'end' as const,
                horizontal: true,
                distributed: true,
            }
        },
        title: {
            text: `Топ 10 категорий по количеству товаров`,
            align: 'center' as const,
            margin: 20,
            style: {

                fontSize: '16px',
                fontWeight: 'bold' as const,
                color: '#FFFFFF'
            },
        },
        subtitle: {
            //text: `${city} / ${store_name}`,
            align: 'center' as const,
            margin: 20,
            style: {

                fontSize: '12px',
                fontWeight: 'bold' as const,
                color: '#FFFFFF'
            },
        },
        colors: ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e',
            '#f48024', '#69d2e7'
        ],
        xaxis: {
            categories: categories,
            labels: {
                style: {
                    colors: 'white',
                    fontWeight: 14,
                    fontSize: '12',

                }
            }
        },
        grid: {
            show: false
        },
        yaxis: {
            labels: {
                show: true,
                style: {
                    colors: 'white',
                    fontWeight: 14,
                    fontSize: '12',

                }
            }
        },
        tooltip: {
            enabled: true,
            theme: 'dark',
            x: {
                show: true,
            },
            y: {
                title: {
                    formatter: function () {
                        return 'Количество продуктов'
                    }
                }
            },
            marker: {
                show: true,
            },
        },
        legend: {
            show: false
        }
    }

    // Отрисовка карточки с горизонтальной столбчатой диаграммой
    return (
        <Card style={{
            backgroundColor: '#293133',
            borderRadius: 20,
            paddingLeft: 20,
            paddingRight: 20,
            width: '50%'
        }}>
            {/* Горизонтальная столбчатая диаграмма ApexCharts */}
            <ReactApexChart
                options={options}
                series={[{data: series}]}
                type={'bar'}
                height={500}
                style={{color: '#FFFFFF'}}
            />
        </Card>
    );
};
